import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { Card, Form, Col } from 'react-bootstrap'

const WorksheetMultiSelectbox = (props) => {

    let lg = props.colLg ? props.colLg : 9;
    let md = props.colMd ? props.colMd : 12;
    const [values, setValues] = useState([]);
    const [masterOptions, setMasterOptions] = useState([]);

    useEffect(() => {
        if (masterOptions.length === 0) {
            setMasterOptions(props.masterQuestionOptions);
        }
    }, [])

    useEffect(() => {
        if (props.value) {
            setValues(props.value);
            
            let masterOptionsLocal = [...props.masterQuestionOptions];

            //props.value.forEach(element => {
            //    masterOptionsLocal.find(el => el.optText === element)["selected"] = true;
            //})
            //setMasterOptions(masterOptionsLocal);
        }
    }, [props.value])


    const onChange = (evt) => {

        //var setValues = values ? [...values] : [];
        //const val = evt.target.value
        //if (setValues.includes(val)) {
        //    // remove it
        //    setValues.splice(setValues.indexOf(val), 1);
        //} else {
        //    // add it
        //    setValues.push(val);
        //}
        // reorder

        var setValues = [].slice
            .call(evt.target.selectedOptions)
            .map(option => option.value)

        setValues = setValues.sort();

        let event = { target: { name: props.name, value: setValues } };

        props.onChangeInput(event);
    }

    //const isSelected = (val) => {
    //    var selected = false;
    //    if (props.value) {
    //        selected = values?.includes(val) ? true : false;
    //    }
    //    return selected;
    //}

    const onBlur = (name, value) => {
        let event = { target: { name: name, value: values } };
        props.onBlur(event);
    }

    if (props.print) {
        return (
            <Form.Group as={Col} lg={lg} md={md}>
                <Form.Label>{props.label}</Form.Label><br />
                {
                    //props.value?.map((val, idx) => {
                    //    return (<div>val</div>)
                    //})
                }
            </Form.Group>
        );
    } else {
        return (

            <Form.Group as={Col} lg={lg} md={md}>
                {/*(event) => onChange(event)*/}
                <Form.Label>{props.label}</Form.Label>
                <Form.Control as="select"
                    name={props.name}
                    id={props.name}
                    size="3"
                    value={values}
                    onChange={evt => onChange(evt)} 
                    onBlur={onBlur}
                    multiple="true"
                    feedback="Initial and Revised values cannot be the same."
                    isInvalid={props.error}>
                    {
                        masterOptions.map((opt, idx) => {
                            return <option key={idx} value={opt.optText} >{opt.optText}</option>
                        })
                    }
                </Form.Control>
                <Form.Text className="text-muted">{props.description}</Form.Text>
                <Form.Control.Feedback type="invalid">
                    Initial and Revised values cannot be the same.
                </Form.Control.Feedback>
            </Form.Group>
        );
    }
}

export default WorksheetMultiSelectbox